import { render, staticRenderFns } from "./QualtList.vue?vue&type=template&id=a2eb7972&scoped=true"
import script from "./QualtList.vue?vue&type=script&lang=js"
export * from "./QualtList.vue?vue&type=script&lang=js"
import style0 from "./QualtList.vue?vue&type=style&index=0&id=a2eb7972&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2eb7972",
  null
  
)

export default component.exports